import { useMemo } from 'react';
import { statusOptions } from 'helpers/constants';
import { SHOW_ALL_OPTION } from '../../constants';

export const useServiceStatuses = (showAll = true) => {
  const serviceStatuses = useMemo(() => {
    // Use the statusOptions from constants and keep original character IDs
    const statuses = statusOptions.map((status) => ({
      id: status.id, // Use original character ID (X, C, P, etc.)
      name: status.name,
      groupBy: status.groupBy,
      statusType: status.groupBy === "Complete" ? "C" : "O"
    }));

    // Add group header options so they can be found during initialization
    const groupOptions = [
      { id: 1, name: "Complete", statusType: "C" },
      { id: 2, name: "Not Complete", statusType: "O" }
    ];

    // Combine all options: Show All + Group Headers + Individual Statuses
    const allOptions = showAll ? [SHOW_ALL_OPTION, ...groupOptions, ...statuses] : [...groupOptions, ...statuses];
    
    return allOptions;
  }, [showAll]);

  return serviceStatuses;
};

// Export group members for external use
export const GROUP_MEMBERS = [
  { id: 1, name: "Complete", statusType: "C" },
  { id: 2, name: "Not Complete", statusType: "O" }
]; 
